import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-cashflow",
  templateUrl: "merchant-cashflow.html",
})
export class MerchantCashflowPage {
  datas = [
    {
      round: 1,
      beginning_cash: {
        beginning_budget: "",
        decoration_cost: "",
        rental_fee: "",
        buy_stock: "",
        revenue_from_shops: "",
      },
      ending_cash: "",
      ending_inventory: "",
    },
  ];
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("token").then((token) => {
      this.storage.get("roundGame").then((round) => {
        var link = this.services.URLMerchantCashFlow;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.datas = data;
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-cashflow/merchant-cashflow.ts